import { render, staticRenderFns } from "./lrTxt.vue?vue&type=template&id=a0d0a458&"
import script from "./lrTxt.vue?vue&type=script&lang=js&"
export * from "./lrTxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports